import { useTranslation } from 'react-i18next';
import FocusDisplay from './FocusDisplay';

export default function CompletedDrillItem({ 
  drill, 
  index, 
  onEdit, 
  onContinue, 
  continueDrillEnabled = false 
}) {
  const { t } = useTranslation();

  return (
    <div className="border-b border-gray-200 pb-3 hover:bg-gray-50 -mx-2 px-2 py-1 rounded-lg transition-colors">
      <div className="flex items-center justify-between gap-2 md:gap-4">
        <div className="flex-1">
          <div 
            onClick={() => onEdit(drill, index)}
            className="font-semibold text-sm md:text-xl text-gray-800 cursor-pointer hover:text-primary-600 transition-colors"
          >
            {drill.originDurationSeconds !== undefined ? (
              <img 
                src="/dagger-edited.png" 
                alt="edited" 
                className="inline-block w-8 h-8 md:w-10 md:h-10 mr-1 align-middle"
              />
            ) : ''} {drill.drillName} - {Math.floor(drill.durationSeconds / 60)}m {drill.durationSeconds % 60}s
          </div>
          {drill.notes && (
            <div className="text-xs md:text-lg text-gray-600 mt-1">{drill.notes}</div>
          )}
          {drill.focus && drill.focus.length > 0 && (
            <FocusDisplay focusIds={drill.focus} />
          )}
        </div>
        {continueDrillEnabled && drill.drill && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onContinue(drill, index);
            }}
            className="px-3 md:px-4 py-1.5 md:py-2 border-2 border-red-500 text-red-600 rounded-lg font-semibold text-xs md:text-sm hover:bg-red-50 active:bg-red-100 transition-colors whitespace-nowrap"
          >
            {t('training.continue_drill')}
          </button>
        )}
      </div>
    </div>
  );
}

